export const linkHoverStyles =
  'hover:underline hover:decoration-accent-500 hover:underline-offset-2';
